import i18n from '@/lib/i18n';

export const ROUTE_PATHS = {
  HOME: '/',
  COPILOT: '/copilot',
  SETTINGS: '/settings',
  VISION_ENRICHMENT: '/vision-enrichment',
  VISION_PRODUCT: '/vision-enrichment/:productId',
  TAXONOMY: '/my-style-ai',
  PERSONALIZATION: '/personalization',
  AUDIENCES: '/behaviors',
  AUDIENCES_CREATE: '/behaviors/create-new-strategy',
  SEO_CONTENT: '/seo-content',
  ANALYTICS: '/analytics',
  STYLIST_AI: '/stylist-ai',
  AUTH_CALLBACK: '/auth/callback',
  MERCHANDISING_COLLECTIONS: '/collections',
  MERCHANDISING_COLLECTION: '/collections/:collectionId',
  MERCHANDISING_COLLECTIONS_SLICE: '/collections/:collectionId/slices/:sliceId',
  PROFILES: '/profiles',
  ADMIN_AUDIT_LOGS: '/admin/audit-logs',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_CUSTOMERS: '/admin/customers',
  ADMIN_CUSTOMERS_CREATE: '/admin/customers/create',
  ADMIN_ONBOARDING: '/admin/onboarding',
  ADMIN_MODELS: '/admin/models',
  ADMIN_PROMPTS: '/admin/prompts',
  ADMIN_CUSTOMERS_EDIT: '/admin/customers/edit/:id',
  ADMIN_USERS: '/admin/users',
  ADMIN_USERS_CREATE: '/admin/users/create',
  ADMIN_USERS_EDIT: '/admin/users/edit/:id',
  ADMIN_TAXONOMY: '/admin/taxonomy',
  ADMIN_SETTINGS: '/admin/settings',
  ADMIN_VOICE_TONE_EXPORTS: '/admin/voice-tone/exports',
  LOGIN: '/login',
  LOGOUT: '/logout',
  NOT_FOUND: '*',
} as const;

export const ERROR_MESSAGES = {
  ACCESS_DENIED: i18n.t('components.ErrorMessages.accessDenied'),
  INVALID_CREDENTIALS: i18n.t('components.ErrorMessages.invalidCredentials'),
  SESSION_EXPIRED: i18n.t('components.ErrorMessages.sessionExpired'),
  INTERNAL_SERVER_ERROR: i18n.t('components.ErrorMessages.internalServerError'),
  INVALID_DATA: i18n.t('components.ErrorMessages.invalidData'),
} as const;
